module.exports = __webpack_public_path__ + "static/media/wedding_help.068c5132.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/wedding_help.svg
// module id = 1350
// module chunks = 50